var React = require('react');

function ArrowDownWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.5 -1.89795e-07L12.5 2.77439L6.25138 6L1.87477e-07 2.77439L2.20561e-07 -3.38856e-07L6.25138 3.22561L12.5 -1.89795e-07Z","fill":"white"}));
}

ArrowDownWhite.defaultProps = {"width":"13","height":"6","viewBox":"0 0 13 6","fill":"none"};

module.exports = ArrowDownWhite;

ArrowDownWhite.default = ArrowDownWhite;
